import { render, staticRenderFns } from "./DivisionTrashView.vue?vue&type=template&id=ca488382&"
import script from "./DivisionTrashView.vue?vue&type=script&lang=js&"
export * from "./DivisionTrashView.vue?vue&type=script&lang=js&"
import style0 from "./DivisionTrashView.vue?vue&type=style&index=0&id=ca488382&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports